<ng-icon
  [name]="ICONS_NAME_MAP[name()]"
  [size]="ICON_SIZE_MAP[size()]"
  [strokeWidth]="strokeWidth()"
  class="md:tw-hidden"
/>
<ng-icon
  [name]="ICONS_NAME_MAP[name()]"
  [size]="ICON_SIZE_MAP[desktopSizeWithFallback()]"
  [strokeWidth]="strokeWidth()"
  class="tw-hidden md:tw-block"
/>
